import "./Houses.css";

import SeparatorJF from "../../blueprints/separator-line/SeparatorJF";
import BlueHouseImg from "../../utils/images/houses/house1.png";
import GreenHouseImg from "../../utils/images/houses/house2.png";
import RedHouseImg from "../../utils/images/houses/house3.png";
import YellowHouseImg from "../../utils/images/houses/house4.png";

function Houses() {
  const houses = [
    {
      name: "Red House",
      color: "#dc3545",
      motto: "Courage & Leadership",
      image: RedHouseImg,
      description:
        "Red House encourages confidence, courage and leadership qualities among students.",
    },

    {
      name: "Blue House",
      color: "#0d6efd",
      motto: "Discipline & Excellence",
      image: BlueHouseImg,
      description:
        "Blue House inspires discipline, dedication and the pursuit of excellence.",
    },

    {
      name: "Green House",
      color: "#198754",
      motto: "Growth & Harmony",
      image: GreenHouseImg,
      description:
        "Green House promotes teamwork, environmental awareness and personal growth.",
    },

    {
      name: "Yellow House",
      color: "#ffc107",
      motto: "Creativity & Energy",
      image: YellowHouseImg,
      description:
        "Yellow House represents enthusiasm, innovation and positive thinking.",
    },
  ];

  return (
    <section className="houses-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="houses-title">
            School <span>Houses</span>
          </h2>

          <SeparatorJF width="420px" color="#0ea5e9" />

          <p className="houses-subtitle">
            Our House System promotes leadership, teamwork, healthy competition
            and character development through academic, cultural and sports
            activities.
          </p>
        </div>

        <div className="houses-grid">
          {houses.map((house, index) => (
            <div
              key={index}
              className="house-card"
              style={{
                borderTop: `6px solid ${house.color}`,
              }}
            >
              <div className="house-image-wrapper">
                <img
                  src={house.image}
                  alt={house.name}
                  className="house-image"
                />
              </div>

              <div
                className="house-badge"
                style={{
                  background: house.color,
                }}
              >
                {house.name}
              </div>

              <div className="house-content">
                <h4>{house.motto}</h4>

                <p>{house.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Houses;
